/**
 * texto -- el escape de HTML del panel, en un solo lugar (deuda 4 de BACKLOG-DEPURACION-P-T1).
 *
 * Por que: habia 49 helpers de escape escritos a mano; 10 solo escapaban "<" y 5 de esos se usaban dentro de
 * atributos con comilla doble (title="...", value="...", data-x="..."): un " en el dato rompia el atributo. Este es el
 * mismo escape completo que ya usaban inventario/core.js y BandejaPropuestasBanco.js, ahora compartido.
 *
 *   esc(valor)   & < > " ' escapados; null y undefined dan '' y el 0 se conserva ('0', no '').
 *
 * Sirve para texto y para atributos con comilla doble o simple. No sirve para meter codigo en un atributo de evento
 * (onclick="...") ni en una URL: eso no se arma con texto.
 *
 * @module presentation/shared/texto
 */

const ENTIDADES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ENTIDADES[c]);
